import { render, staticRenderFns } from "./academic-result.vue?vue&type=template&id=16b3bbb2&"
import script from "./academic-result.vue?vue&type=script&lang=js&"
export * from "./academic-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports